// eslint-disable-next-line import/prefer-default-export
export const ROOT_ELEMENT_ID = 'not-approved-page-web-app';
